import { Hero } from "frno-react";
import "./PageHeader.scss";
import useTextStore from "../state/TextStore";
export default function PageHeader() {
  const { getTextByKey } = useTextStore();

  const breadcrumbs = [
    {
      href: "/",
      value: getTextByKey("pageheader.breadcrumbs.home"),
    },
    {
      href: "/finansportalen/",
      value: getTextByKey("pageheader.breadcrumbs.finance"),
    },
    {
      href: "/finansportalen/pensjon/",
      value: getTextByKey("pageheader.breadcrumbs.pension"),
    },
    {
      href: "",
      value: getTextByKey("pageheader.breadcrumbs.thefeecheck"),
    },
  ];

  return (
    <Hero
      title={getTextByKey("pageheader.title")}
      text={getTextByKey("pageheader.content")}
      breadcrumbs={breadcrumbs}
      image={null}
      className="surface-secondary hero-spacing"
    />
  );
}
